import React, {useState, useEffect} from 'react';
import { numShortForm } from '../../helper/custom-function';

function WalletCounter({ value }) {
    const [displayValue, setDisplayValue] = useState(value);
    useEffect(() => {
      let start = displayValue;
      let end = value;
      let duration = 500;
      let startTime = performance.now();
  
      const animate = (time) => {
        let progress = Math.min((time - startTime) / duration, 1);
        let current = Math.floor(start + (end - start) * progress);
        // setDisplayValue(numShortForm(current));
        setDisplayValue(current);
        if (progress < 1) requestAnimationFrame(animate);
      };
  
      requestAnimationFrame(animate);
    }, [value]);// eslint-disable-line react-hooks/exhaustive-deps
  
    return <span className="wallet-count">{numShortForm(displayValue)}</span>;
}

export {WalletCounter};